<template>  
        <div class="mobile-menu">
            <div :class="{ bg: showMenu }" class="bg-top"></div>    
            <div class="menu" :class="{ menu_active: showMenu }">       
                <div class="menu-btn-block">
                    <div class="menu-btn" @click="menuDisplay()"><span></span></div>
                </div>        
                <nav class="menu-list">
                    <a v-for="(route,index) in routesShow" :key="index" :href="route.path" @click.prevent="menuDisplay(route)">{{getCaption(route)}}</a>                
                </nav>
            </div>
        </div>            
</template>

<script>
export default {
    data(){
        return {
            showMenu:false,
            routesShow:this.routes
        }
    },
    props:['routes','pages'],
    methods: {
        getCaption(route){
            let alias = route.path.split("/")
            let pagecaption = this.pages.find(page => page.alias == alias[alias.length-1]) 
            return (pagecaption && pagecaption.caption) ? pagecaption.caption : route.name
        },  
        menuDisplay(route){
            if(route){
                if(route.children){
                    this.routesShow=route.children
                }else{
                    this.showMenu=!this.showMenu               
                    this.$router.push(route).catch(()=>{})
                    this.routesShow=this.routes
                }                
            }else{
                this.showMenu=!this.showMenu
                this.routesShow=this.routes
            }
        }
  },
};
</script>

<style lang="scss">

.bg-top{
    width: 100vw;
    height: 50px;
    background-color: rgba(0, 0, 0,0.4);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 5;
}
.bg{
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left:0;
    z-index: 98;
    background-color: #000;
    opacity: 0.2;
  }
  .menu {
    position: fixed;
    left: 0;top: 0;
    z-index: 99;
    width: 100%;
    min-width: 300px;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    transition: 0.5s;
    transform: translateX(-100%);   
    &-list{
        display: flex;
        justify-content: space-around;
        align-items: center;
        height: 70%;
        flex-direction: column;
        a{
            display: block;
            text-decoration: none;
            text-transform: uppercase;
            font-weight: 700;
            color: #555;
            text-align: center;
        }
    }
    &-btn{
        display: block;
        width: 50px;
        height: 50px;
        background-color: rgba(0, 0, 0,0.4);
        position: relative;
        cursor: pointer;
        &-block{
            position: absolute;
            right: -50px;
            top: 0;
        }
        span,span::before,span::after{
            position: absolute;
            top: 50%; margin-top: -2px;
            left: 50%; margin-left: -10px;
            width: 20px;
            height: 3px;
            background-color: #fff;            
        }
        span{
            &::before{
                content: '';
                display: block;
                transition: 0.2s;  
                transform: translateY(-6px);              
            }
            &::after{
                content: '';
                display: block;
                transition: 0.2s;
                transform: translateY(6px);
            }
        }
    }
    &_active{
        transform: translateX(0%);
        .menu-btn-block{
            right: auto;            
            .menu-btn {
                background-color: transparent;
                span{
                    background-color: transparent;
                    &::before{
                        transform: rotate(-45deg);
                        width: 30px;
                        transform-origin: 50% 50%;
                        height: 4px;
                        background-color: #555;
                    }
                    &::after{
                        transform: rotate(45deg);
                        width: 30px;
                        transform-origin: 50% 50%;    
                        height: 4px;    
                        background-color: #555;
                  }
                }
            }           
        }
    }
    @media(min-width:768px){
        width: 50%;
    }
    @media(min-width:992px){
        width: 30%;
    &-btn{
        width: 70px;
        height: 70px;
        &-block{
            right: -75px;
        }
        span,span::before,span::after{
            width: 40px;
            height: 4px;
            margin-left: -20px;
            margin-top: -2px;           
        }
        span{
            &::before{
                transform: translateY(-10px);              
            }
            &::after{
                transform: translateY(10px);
            }
        }
    }
    &_active{
        .menu-btn-block{
            right: -75px;
            .menu-btn span{
                &::before,&::after{
                    width: 40px;
                }
                 
            }           
        }
    }
    }

  } 
</style>